import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { CompetitorProductLayer } from '../../transportLayers/product/CompetitorProductLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of products.
 */

export var CompetitorProductStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CompetitorProductStore, _BaseStore);

  function CompetitorProductStore(rootStore) {
    var _this;

    _classCallCheck(this, CompetitorProductStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductStore).call(this, rootStore));
    _this.name = StoreName.CompetitorProduct;
    _this.competitorProductLayer = new CompetitorProductLayer();
    _this.list = new Map();
    return _this;
  }

  _createClass(CompetitorProductStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.competitorProductLayer.findAll().then(function (competitorProducts) {
        runInAction(function () {
          competitorProducts.forEach(function (competitorProduct) {
            if (competitorProduct.id) {
              _this2.list.set(competitorProduct.id, competitorProduct);
            }
          });
        });
      });
    }
  }, {
    key: "getOne",
    value: function getOne(productId) {
      var _this3 = this;

      return this.competitorProductLayer.findOne(productId).then(function (competitorProduct) {
        runInAction(function () {
          _this3.list.set(competitorProduct.id, competitorProduct);
        });
        return competitorProduct;
      });
    }
  }]);

  return CompetitorProductStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CompetitorProductStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], CompetitorProductStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], CompetitorProductStore.prototype, "getOne", null);